export default "__VITE_ASSET__88O5xpYc__"